import React, { Suspense, lazy, Fragment } from "react";

const ThemeColorContext = React.createContext({ changeThemeColor: () => { } });

export default ThemeColorContext